export const RFP_Id = '00000000-0000-0000-0000-000000000000';
export const RFP_name = 'RFP';